<template>
    <div>
        <v-client-table :columns="columns" :options="options" :data="records">

            <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

            </div>

            <div slot="afterFilter" class="ml-2">
                <router-link :to="`/inspections/${inspection.id}/audit/create`" class="btn btn-success ml-1" v-if="inspection">
                    <i class="fas fa-plus-square"></i> Entry
                </router-link>
            </div>

            <div slot="id" slot-scope="props">
                <b-dropdown text="Left align" variant="default" no-caret size="sm">
                    <template v-slot:button-content>
                        <i class="fas fa-ellipsis-h"></i>
                    </template>
                    <b-dropdown-item href="javascript:void(0)" v-on:click="editAudit(props.row.id)"><i class="fas fa-edit"></i> Edit</b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0)" v-on:click="deleteAudit(props.row.id)" class="text-danger"><i class="fas fa-trash"></i> Delete</b-dropdown-item>
                </b-dropdown>
            </div>

            <template slot="legacy_local_index" slot-scope="props">
                <router-link :to="`/inspections/${props.row.inspection_id}`">{{ props.row.legacy_local_index }}</router-link>
            </template>

            <template slot="part_nbr" slot-scope="props">
                <router-link :to="`/parts/${props.row.part_id}`" title="View Part">{{ props.row.part_nbr }}</router-link>
            </template>

            <template slot="audit_date" slot-scope="props">
                {{ props.row.audit_date | moment("MM/DD/YYYY") }}
            </template>

            <template slot="time_in_seconds_actual" slot-scope="props">
                {{ props.row.time_in_seconds_actual | humanReadableTime }}
            </template>

            <template slot="time_in_seconds_billable" slot-scope="props">
                {{ props.row.time_in_seconds_billable | humanReadableTime }}
            </template>
        </v-client-table>
    </div>
</template>

<script>
    export default {
        props: {
            inspection: {
                type: Object,
                required: false,
                default: null
            },

            records: {
                type: Array,
                required: true
            },

            showSearchAndActions: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                userTimezone: this.$root.timezone,
                showFilters: false,
                options: {
                    perPage: 10,
                    headings: {
                        id: 'Actions',
                        name: 'Associate',
                        legacy_local_index: 'Index',
                        part_nbr: 'Part#',
                        description: 'Desc.',
                        audit_date: 'Date',
                        qty_defect: 'Qty Rejected',
                        qty_rework: 'Qty Rework',
                        qty_audited: 'Qty Audited',
                        shift_name: 'Shift',
                        shift_walk_name: 'Walk',
                        //time_in_seconds_actual: 'Actual',
                        //time_in_seconds_billable: 'Billable',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'audit_date',
                    },
                    texts:{
                        filterPlaceholder:"Search Entries",
                    },
                    uniqueKey: 'id',
                    filterable: this.showSearchAndActions,
                },
            }
        },

        computed: {

            columns(){
                //Check for an inspection
                if(!this.inspection)
                {
                    return ['id', 'name', 'legacy_local_index', 'part_nbr', 'description', 'audit_date', 'qty_defect', 'qty_rework', 'qty_audited', 'shift_name', 'shift_walk_name'];
                }

                //Default
                return ['id', 'name', 'part_nbr', 'description', 'audit_date', 'qty_defect', 'qty_rework', 'qty_audited', 'shift_name', 'shift_walk_name'];
            }
        },

        methods: {

            editAudit(id){
                this.$router.push('/inspections/'+this.inspection.id+'/audit/'+id);
            },

            deleteAudit(id){
                this.$router.push('/inspections/'+this.inspection.id+'/audit/'+id+'/delete');
            }
        },

        mounted() {

        }
    }
</script>
